import { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/layout/Navbar.css';

function Navbar({isMenuOpen, setIsMenuOpen}) {
    const [openDropdown, setOpenDropdown] = useState(null);
  const [isAtTop, setIsAtTop] = useState(true);
  const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 768px)').matches);
    const closeTimeoutRef = useRef(null);
  const location = useLocation();

  const isSupportRoute = ['/about', '/contact', '/faq', '/support'].includes(location.pathname);

  useEffect(() => {
    const updateScrollState = () => {
      setIsAtTop(window.scrollY === 0);
    };

    updateScrollState();
    window.addEventListener('scroll', updateScrollState, { passive: true });

    return () => {
      window.removeEventListener('scroll', updateScrollState);
    };
  }, [location.pathname]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleChange = (event) => setIsMobile(event.matches);

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  const closeDropdown = () => {
    setOpenDropdown(null);
    setIsMenuOpen(false);
  };

    const handleMouseEnter = (dropdown) => {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
        setOpenDropdown(dropdown);
    };

    const handleMouseLeave = () => {
        closeTimeoutRef.current = setTimeout(() => {
            setOpenDropdown(null);
        }, 120);
    };

    const getDropdownHoverHandlers = (dropdown) => {
        if (isMobile) {
            return {};
        }

        return {
            onMouseEnter: () => handleMouseEnter(dropdown),
            onMouseLeave: handleMouseLeave,
        };
    };

    const toggleMobileDropdown = (dropdown) => {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }

        setOpenDropdown((current) => (current === dropdown ? null : dropdown));
    };

    useEffect(() => {
        if (!isMenuOpen) {
            setOpenDropdown(null);
        }
    }, [isMenuOpen]);

    useEffect(() => {
        document.body.classList.toggle('nav-menu-open', isMenuOpen && isMobile);

        return () => {
            document.body.classList.remove('nav-menu-open');
        };
    }, [isMenuOpen, isMobile]);

    return (
        <nav className={`navbar ${isSupportRoute && isAtTop ? 'navbar--blend' : ''}`}>
        <div className="container">
          <div className="nav-wrapper">
            <div className="logo">
              <Link to="/" onClick={closeDropdown}><img src="/logo1.png" alt="Sonny Blind" className="logo-img" /></Link>
            </div>
            
            <button 
              className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`}
              onClick={() => {
                if (closeTimeoutRef.current) {
                  clearTimeout(closeTimeoutRef.current);
                  closeTimeoutRef.current = null;
                }
                setIsMenuOpen((open) => !open);
              }}
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={isMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <button
              type="button"
              className={`mobile-menu-backdrop ${isMenuOpen ? 'active' : ''}`}
              aria-label="Close menu"
              aria-hidden={!isMenuOpen}
              tabIndex={isMenuOpen ? 0 : -1}
              onClick={() => setIsMenuOpen(false)}
            />

            <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
              <li><Link to="/" onClick={closeDropdown}>HOME</Link></li>
              <li className="separator">|</li>

              {/* Products & Services — mega menu */}
              <li
                className={`dropdown mega-menu ${openDropdown === 'products' ? 'open' : ''}`}
                {...getDropdownHoverHandlers('products')}
              >
                {isMobile ? (
                  <button
                    type="button"
                    className="dropdown-toggle"
                    aria-expanded={openDropdown === 'products'}
                    onClick={() => toggleMobileDropdown('products')}
                  >
                    PRODUCTS &amp; SERVICES<span className="chevron-down"></span>
                  </button>
                ) : (
                  <Link
                    to="/products"
                    className="dropdown-toggle"
                    onClick={closeDropdown}
                  >
                    PRODUCTS &amp; SERVICES<span className="chevron-down"></span>
                  </Link>
                )}
                <div
                  className={`dropdown-content mega-content ${openDropdown === 'products' ? 'open' : ''}`}
                  {...getDropdownHoverHandlers('products')}
                >
                  <div className="mega-menu-grid">
                    <div className="mega-menu-column">
                      <h3>BLINDS</h3>
                      <Link to="/product/vertical-blind" onClick={closeDropdown}>VERTICAL BLIND</Link>
                      <Link to="/product/aluminum-blind" onClick={closeDropdown}>ALUMINUM BLIND</Link>
                      <Link to="/product/wood-blind" onClick={closeDropdown}>WOOD BLIND</Link>
                      <Link to="/product/faux-blind" onClick={closeDropdown}>FAUX BLIND</Link>
                    </div>
                    <div className="mega-menu-column">
                      <h3>SHUTTERS</h3>
                      <Link to="/product/plantation-shutter" onClick={closeDropdown}>PLANTATION SHUTTERS</Link>
                      <Link to="/product/eclipse-shutter" onClick={closeDropdown}>ECLIPSE® SHUTTERS</Link>
                    </div>
                    <div className="mega-menu-column">
                      <h3>SHADES</h3>
                      <Link to="/product/honeycomb-shade" onClick={closeDropdown}>HONEYCOMB</Link>
                      <Link to="/product/sheer-shade" onClick={closeDropdown}>SHEER SHADE</Link>
                      <Link to="/product/revolve-shade" onClick={closeDropdown}>REVOLVE SHADE</Link>
                      <Link to="/product/roller-shade" onClick={closeDropdown}>ROLLER SHADE</Link>
                      <Link to="/product/outdoor-shade" onClick={closeDropdown}>OUTDOOR</Link>
                    </div>
                  </div>
                </div>
              </li>

              <li className="separator">|</li>

              {/* Customer Support — regular dropdown */}
              <li
                className={`dropdown ${openDropdown === 'support' ? 'open' : ''}`}
                {...getDropdownHoverHandlers('support')}
              >
                
                {isMobile ? (
                  <button
                    type="button"
                    className="dropdown-toggle"
                    aria-expanded={openDropdown === 'support'}
                    onClick={() => toggleMobileDropdown('support')}
                  >
                    CUSTOMER SUPPORT<span className="chevron-down"></span>
                  </button>
                ) : (
                  <Link
                    to="/support"
                    className="dropdown-toggle"
                    onClick={closeDropdown}
                  >
                    CUSTOMER SUPPORT<span className="chevron-down"></span>
                  </Link>
                )}

                <div
                  className={`dropdown-content support-content ${openDropdown === 'support' ? 'open' : ''}`}
                  {...getDropdownHoverHandlers('support')}
                >
                  <Link to="/about" onClick={closeDropdown}>ABOUT US</Link>
                  <Link to="/contact" onClick={closeDropdown}>CONTACT US</Link>
                  <Link to="/faq" onClick={closeDropdown}>FAQ</Link>
                </div>
              </li>

              <li className="separator">|</li>
              <li><Link to="/contact" className="btn-quote" onClick={closeDropdown}>CONTACT US</Link></li>
            </ul>
          </div>
        </div>
      </nav>
    )
}

export default Navbar;